export enum KVInputProfile {
  Default = 'Default',
  Switched = 'Switched',
  Creo = 'Creo',
}

export type KVSettingsJSON = {
  orbitSpeed: number
  inputProfile: string
}

export class KVSettings {
  orbitSpeed: number
  inputProfile: KVInputProfile

  constructor() {
    this.orbitSpeed = 0.7
    this.inputProfile = KVInputProfile.Default
  }

  static fromJSON(json: KVSettingsJSON): KVSettings {
    const settings = new KVSettings()
    if (json.orbitSpeed) settings.orbitSpeed = json.orbitSpeed
    if (json.inputProfile) {
      // Validate and convert string to enum
      if (
        Object.values(KVInputProfile).includes(
          json.inputProfile as KVInputProfile
        )
      ) {
        settings.inputProfile = json.inputProfile as KVInputProfile
      }
    }
    return settings
  }
}
